import React from "react";
import { Nav, Navbar, Container } from "react-bootstrap";
import NavStyle from "./Nav.module.css";
import "style.css";

const Navigation = () => {
  const navBar = NavStyle.navBar;
  const containerNav = NavStyle.containerNav;
  return (
    <>
      <Navbar className={navBar} expand="lg">
        <Container className={containerNav}>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link href="/" >
                Home
              </Nav.Link>
              <Nav.Link href="/#right" >
                BioMazze Is The Right Choice
              </Nav.Link>
              <Nav.Link href="/#about" >
                About Brandis
              </Nav.Link>
              <Nav.Link href="/#train" >
                Training
              </Nav.Link>
              <Nav.Link href="/#bio" >
                BioMazze Coordination
              </Nav.Link>
              <Nav.Link href="/#hire" >
                Apply For Work
              </Nav.Link>
              <Nav.Link href="/#contact" >
                Contact
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};
export default Navigation;
